module.exports = __webpack_public_path__ + "img/uk-external-causes-female.f42fe1b8.png";